var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo, useRef } from 'react';
import { styled } from 'styled-components';
import { Pie } from '@nivo/pie';
import { Tooltip } from '@hn-ui/tooltips';
import defaultTheme from '../../../../../landing/components/core/themes/theme';
var Container = styled.div.withConfig({ displayName: "Container", componentId: "sc-1iwcug3" })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n\n  & svg text[dominant-baseline='central'] {\n    dominant-baseline: auto !important;\n  }\n"], ["\n  position: relative;\n\n  & svg text[dominant-baseline='central'] {\n    dominant-baseline: auto !important;\n  }\n"])));
var StudentTooltipContainer = styled.div.withConfig({ displayName: "StudentTooltipContainer", componentId: "sc-1s6lmuu" })(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  max-height: 183px;\n  overflow-y: scroll;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 24px;\n  &::-webkit-scrollbar {\n    /* stylelint-disable property-no-vendor-prefix */\n    -webkit-appearance: none;\n  }\n  &::-webkit-scrollbar:vertical {\n    width: 8px;\n  }\n  &::-webkit-scrollbar-thumb {\n    border-radius: 4px;\n    border: 2px solid white;\n    background-color: #d7dde4;\n  }\n"], ["\n  max-height: 183px;\n  overflow-y: scroll;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 24px;\n  &::-webkit-scrollbar {\n    /* stylelint-disable property-no-vendor-prefix */\n    -webkit-appearance: none;\n  }\n  &::-webkit-scrollbar:vertical {\n    width: 8px;\n  }\n  &::-webkit-scrollbar-thumb {\n    border-radius: 4px;\n    border: 2px solid white;\n    background-color: #d7dde4;\n  }\n"])));
var StudentTooltipItem = styled.div.withConfig({ displayName: "StudentTooltipItem", componentId: "sc-dt342r" })(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n"], ["\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n"])));
var CustomSlices = function (_a) {
    var dataWithArc = _a.dataWithArc, arcGenerator = _a.arcGenerator, centerX = _a.centerX, centerY = _a.centerY, prefix = _a.prefix;
    return (_jsx("g", __assign({ transform: "translate(" + centerX + "," + centerY + ")" }, { children: dataWithArc.map(function (el) {
            if (!el.value)
                return null;
            var _a = el.data, id = _a.id, students = _a.students;
            return (_jsx(Tooltip, __assign({ content: _jsx(StudentTooltipContainer, { children: students.map(function (s, i) { return (_jsx(StudentTooltipItem, { children: s.name }, i)); }) }, void 0), width: 193 }, { children: _jsx("path", { d: arcGenerator(el.arc), fill: el.color, strokeWidth: '1', stroke: defaultTheme.colors.black100 }, void 0) }), id + "-" + prefix));
        }) }), void 0));
};
var RoundedSquareShape = function (_a) {
    var x = _a.x, y = _a.y, size = _a.size, fill = _a.fill, borderWidth = _a.borderWidth, borderColor = _a.borderColor;
    return (_jsx("rect", { x: x, y: y, fill: fill, strokeWidth: borderWidth, stroke: borderColor, width: size, height: size, rx: 2, style: { pointerEvents: 'none' } }, void 0));
};
var baseLegend = {
    itemWidth: 0,
    itemHeight: 20,
    itemsSpacing: 5,
    symbolSize: 10,
    itemDirection: 'left-to-right',
};
var rightLegend = __assign(__assign({}, baseLegend), { anchor: 'right', direction: 'column', justify: false, translateX: 6, translateY: 4, itemsSpacing: 3, itemDirection: 'left-to-right', symbolShape: RoundedSquareShape });
var PieBase = function (_a) {
    var data = _a.data, _b = _a.legend, legend = _b === void 0 ? { position: 'right', colors: [] } : _b, width = _a.width, _c = _a.prefix, prefix = _c === void 0 ? '' : _c, rest = __rest(_a, ["data", "legend", "width", "prefix"]);
    var pieRef = useRef(null);
    var radians = useRef(0);
    var legends = legend.position === 'right' ? [rightLegend] : [];
    var margins = useMemo(function () {
        if (legend.position === 'right') {
            return { top: 34, right: 98, bottom: 30, left: 0 };
        }
        return { top: 36, right: 30, bottom: 30, left: 30 };
    }, [legend.position]);
    return (_jsx(Container, __assign({ className: prefix + "_PieContainer" }, rest, { children: _jsx(Pie, { ref: pieRef, data: data, width: width, height: 148, margin: margins, radialLabelsLinkOffset: 4, padAngle: 0, enableSliceLabels: false, radialLabelsTextColor: defaultTheme.colors.blackText, radialLabelsLinkColor: '#C5C7D4', radialLabelsLinkHorizontalLength: 24, radialLabelsLinkDiagonalLength: 16, radialLabelsSkipAngle: 2, 
            // doesn't allow to return an element. It's fixed by the new version
            // @ts-ignore
            radialLabel: function (_a) {
                var id = _a.id, _b = _a.value, value = _b === void 0 ? 0 : _b, _c = _a.data.students, students = _c === void 0 ? [] : _c, angle = _a.arc.angle;
                if (radians.current >= Math.PI * 2)
                    radians.current = 0;
                var targetDx = value.toString().length === 1 ? 18 : 20;
                var dx = (radians.current + angle / 2 < Math.PI ? -targetDx : targetDx - 4) + "px";
                radians.current += angle;
                return (_jsx(Tooltip, __assign({ id: prefix + "_Students", width: 193, content: _jsx(StudentTooltipContainer, { children: students.map(function (s) { return (_jsx(StudentTooltipItem, { children: s.name }, id + "-" + s.name)); }) }, void 0) }, { children: _jsx("tspan", __assign({ dx: dx, dy: '-4px' }, { children: value }), void 0) }), id + "-" + prefix));
            }, layers: [
                'radialLabels',
                'legends',
                function (slicesProps) { return _jsx(CustomSlices, __assign({}, slicesProps, { prefix: prefix }), void 0); },
            ], colors: function (d) {
                var _a, _b, _c;
                if (legend && ((_a = legend.colors) === null || _a === void 0 ? void 0 : _a.length)) {
                    return ((_c = (_b = legend.colors.find(function (c) { return c.grade === d.data.id; })) === null || _b === void 0 ? void 0 : _b.color) !== null && _c !== void 0 ? _c : '');
                }
                return d.data.color;
            }, legends: legends, theme: {
                fontSize: 14,
                fontFamily: 'Noto Sans',
                legends: { text: { fontSize: 10, fontWeight: 'bold' } },
            }, isInteractive: true, fit: false, tooltip: function () { return null; } }, void 0) }), void 0));
};
export { PieBase };
var templateObject_1, templateObject_2, templateObject_3;
